module.exports = [{
  name: "AWP Blaster",
  src: "weapon_1",
  icon: "icon_1",
  assetIcon: "",
  sound: "weapon_1",
  refDist: 25,
  rollOff: 1,
  equipment: false,
  secondary: false,
  noSpread: false,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 100,
  pj_spd: 2.5,
  pj_lookDir: true,
  pj_grav: 0.0001,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 7000,
  pj_snd: 0,
  akimbo: false,
  noAim: false,
  animWhileAim: true,
  trail: true,
  flap: {
    src: "flap_0",
    rot: 2.1,
    scl: 1,
    zOff: 0.43,
    xOff: 0.17,
    yOff: 0.53
  },
  physRang: 0,
  physPow: 0,
  burst: true,
  burstC: 2,
  burstR: 100,
  spread: 180,
  minSpread: 20,
  noAo: true,
  nAuto: true,
  type: 0,
  scope: true,
  swapTime: 300,
  aimSpd: 120,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 0.95,
  ammo: 12,
  dmg: 100,
  hsMlt: 1.5,
  pierce: 0.2,
  reload: 1200,
  range: 1000,
  dropStart: 230,
  dmgDrop: 30,
  scale: 0.00115608717587935,
  leftHoldY: -0.65,
  rightHoldY: -0.68,
  leftHoldZ: 2.1,
  rightHoldZ: 0.75,
  holdW: 1,
  xOff: 0.8,
  yOff: -0.65,
  zOff: -1.8,
  xOrg: 0,
  yOrg: -0.55,
  zOrg: -0.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  inspectR: 0.2,
  inspectM: 0.1,
  muzOff: 8,
  muzMlt: 1.6,
  rate: 280,
  spread: 260,
  zoom: 2.7,
  leanMlt: 1.5,
  recoil: 0.009,
  recoilR: 0.05,
  recover: 0.993,
  recoverY: 0.997,
  recoverF: 0.975,
  recoilYM: 0.55,
  recoilZ: 1.5,
  recoilAnim: {
    time: 280,
    aimTime: 500,
    recoilTweenY: 0.24
  },
  jumpYM: 0.15,
  rumble: 0.9,
  rumbleDur: 500,
  icnPad: 9,
  charm: true,
  charmMXOff: -0.37,
  charmMYOff: -0.4,
  charmMZOff: -0.91,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 10,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Zombie Assaulter",
  src: "weapon_2",
  icon: "icon_2",
  assetIcon: "",
  sound: "weapon_2",
  refDist: 25,
  rollOff: 1,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 23,
  pj_spd: 2.6,
  pj_lookDir: true,
  pj_grav: 0.00011,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 3000,
  pj_snd: 0,
  equipment: false,
  secondary: false,
  noSpread: false,
  akimbo: false,
  noAim: false,
  noAo: true,
  nAuto: false,
  physRang: 0,
  physPow: 0,
  swapWiggle: 0.3,
  attach: 0,
  attachYOff: -0.07,
  attachZOff: -0.8,
  zRot: 1,
  type: 0,
  swapTime: 300,
  aimSpd: 130,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 0.95,
  ammo: 35,
  rate: 90,
  reload: 1500,
  dmg: 28,
  hsMlt: 1.5,
  pierce: 1,
  range: 700,
  dmgDrop: 5,
  scale: 0.00095745145728643,
  leftHoldY: -0.41,
  rightHoldY: -0.6,
  leftHoldZ: 0.5,
  rightHoldZ: -1.2,
  holdW: 0.8,
  xOff: 0.7,
  yOff: -0.87,
  zOff: -3.33,
  rotOff: -0.08,
  rotOffA: -0.035,
  aimOffY: 0.042,
  yRot: 0.0018,
  xOrg: 0,
  yOrg: -0.59,
  zOrg: -2.14,
  cLean: 0.2,
  cRot: 0.1,
  cDrop: 0.1,
  inspectR: 0.1,
  inspectM: 1.5,
  caseZOff: -1.7,
  caseYOff: -0.2,
  muzOff: 5.1,
  muzOffY: -0.05,
  muzMlt: 1.4,
  spread: 100,
  minSpread: 5,
  zoom: 1.6,
  leanMlt: 1.5,
  recoil: 0.003,
  recoilR: 0.05,
  recover: 0.978,
  recoverY: 0.995,
  recoverF: 0.975,
  jYMlt: 0.9,
  recoilYM: 1.1,
  recoilZ: 4.3,
  recoilZM: -0.04,
  aimRecMlt: 0.65,
  recoilAnim: {
    time: 160,
    recoilTweenY: 0.065,
    recoilTweenZ: 0.1
  },
  jumpYM: 0.3,
  rumble: 0.5,
  icnPad: 5,
  charm: true,
  charmMXOff: -0.37,
  charmMYOff: -0.3,
  charmMZOff: 1.19,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  muzID: 3,
  magReserve: 7,
  mysteryBoxR: 2,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Pistol",
  src: "weapon_3",
  icon: "icon_3",
  assetIcon: "",
  sound: "weapon_3",
  refDist: 25,
  rollOff: 1,
  secondary: true,
  equipment: false,
  noSpread: false,
  akimbo: false,
  noAim: false,
  noAo: true,
  transp: true,
  nAuto: true,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 12,
  pj_spd: 2.3,
  pj_lookDir: true,
  pj_grav: 0.0001,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 1600,
  pj_snd: 0,
  physRang: 0,
  physPow: 0,
  kill: ["", 75],
  swapWiggle: 0.3,
  type: 1,
  shine: 10,
  swapTime: 260,
  aimSpd: 110,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1.05,
  ammo: 16,
  reload: 700,
  dmg: 20,
  hsMlt: 1.5,
  range: 700,
  dmgDrop: 10,
  scale: 0.0003158947055276376,
  leftHoldY: -1.1,
  rightHoldY: -0.62,
  leftHoldZ: -0.3,
  rightHoldZ: -0.32,
  rightHoldX: 0.13,
  holdW: 1.3,
  xOff: 1.2,
  yOff: -0.6,
  zOff: -3.7,
  xOrg: 0,
  yRot: -0.005,
  yOrg: -0.23,
  zOrg: -3.9,
  jYMlt: 0.1,
  cLean: 0.3,
  cRot: 0.3,
  caseZOff: 0.2,
  caseYOff: 0,
  inspectR: 0.3,
  inspectM: 0.8,
  muzID: 3,
  muzOff: 1.5,
  muzOffY: 0,
  muzMlt: 0.95,
  rate: 100,
  spread: 60,
  zoom: 1.4,
  leanMlt: 1,
  recoil: 0.006,
  recoilR: 0.02,
  recover: 0.98,
  recoverY: 0.99,
  recoverF: 0.98,
  recoilYM: 0.2,
  aimRecMlt: 0.4,
  recoilZ: 3.8,
  recoilZM: -0.4,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.28,
    recoilTweenZ: 0.1
  },
  rumble: 0.4,
  icnPad: -15,
  expScale: 0.8,
  charm: true,
  charmMXOff: -0.37,
  charmMYOff: -0.2,
  charmMZOff: 0.91,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 7,
  mysteryBoxR: 0,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "UMPire",
  src: "weapon_4",
  icon: "icon_4",
  assetIcon: "",
  sound: "weapon_4",
  refDist: 25,
  rollOff: 1,
  secondary: false,
  equipment: false,
  noSpread: false,
  nAuto: false,
  noAim: false,
  akimbo: false,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 18,
  pj_spd: 2.4,
  pj_lookDir: true,
  pj_grav: 0.00011,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 2700,
  pj_snd: 0,
  physRang: 0,
  physPow: 0,
  swapWiggle: 0.5,
  attach: 0,
  attachYOff: -0.09,
  attachZOff: -1.1,
  zRot: 0.75,
  noAo: true,
  type: 0,
  shine: 50,
  swapTime: 300,
  aimSpd: 110,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1.04,
  ammo: 44,
  reload: 1000,
  dmg: 24,
  hsMlt: 1.5,
  pierce: 1,
  range: 700,
  dmgDrop: 12,
  scale: 0.000574897587939697,
  leftHoldY: -0.4,
  leftHoldX: -0.1,
  leftHoldZ: 1.1,
  rightHoldZ: -0.95,
  rightHoldY: -0.5,
  holdW: 0.85,
  xOff: 0.85,
  yOff: -0.86,
  zOff: -3,
  xOrg: 0,
  yOrg: -0.59,
  zOrg: -2.5,
  cRot: 0.18,
  cLean: 0.16,
  inspectR: 0.2,
  inspectM: 1.2,
  caseYOff: -0.15,
  caseZOff: -0.4,
  muzID: 3,
  muzOff: 2.15,
  muzOffY: 0.1,
  rate: 80,
  spread: 70,
  minSpread: 5,
  zoom: 1.65,
  jYMlt: 0.8,
  leanMlt: 1,
  recoil: 0.0034,
  recoilY: 0.77,
  recoilYM: 0.3,
  recoilR: 0.065,
  recover: 0.975,
  recoverY: 0.996,
  recoverF: 0.975,
  recoilZ: 4.2,
  recoilZM: -0.1,
  aimRecMlt: 0.6,
  recoilAnim: {
    time: 190,
    recoilTweenYM: 0.05,
    recoilTweenY: 0.06,
    recoilTweenZ: 0.14
  },
  expScale: 0.8,
  rumble: 0.4,
  icnPad: 0,
  charm: true,
  charmMXOff: -0.35,
  charmMYOff: 0.17,
  charmMZOff: 1.53,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 7,
  mysteryBoxR: 2,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Revolver",
  src: "weapon_5",
  icon: "icon_5",
  assetIcon: "",
  sound: "weapon_5",
  refDist: 25,
  rollOff: 1,
  secondary: false,
  equipment: false,
  noSpread: false,
  akimbo: false,
  noAim: false,
  nAuto: true,
  noAo: true,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 66,
  pj_spd: 2.3,
  pj_lookDir: true,
  pj_grav: 0.0001,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 2600,
  pj_snd: 0,
  physRang: 0,
  physPow: 0,
  nCase: true,
  transp: true,
  kill: ["", 50],
  type: 0,
  swapTime: 200,
  swapWiggle: 0.4,
  aimSpd: 110,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1.04,
  burst: true,
  burstC: 3,
  burstR: 90,
  ammo: 12,
  reload: 900,
  dmg: 66,
  hsMlt: 1.5,
  pierce: 0.85,
  dmgDrop: 10,
  scale: 0.000515531266331653,
  hDstOff: 1.6,
  leftHoldY: -1.3,
  rightHoldY: -0.8,
  leftHoldZ: -0.6,
  rightHoldZ: -0.72,
  rightHoldX: 0.1,
  holdW: 1.1,
  rotOff: -0.05,
  xOff: 0.7,
  yOff: -0.5,
  zOff: -3.5,
  xOrg: 0,
  yOrg: -0.31,
  zOrg: -3.5,
  jYMlt: 0.4,
  cLean: 0.2,
  cRot: 0.1,
  cDrop: 0.1,
  inspectR: 0.1,
  inspectM: 0.3,
  muzID: 3,
  muzOff: 2.75,
  muzOffY: 0.2,
  muzMlt: 0.95,
  range: 700,
  rate: 450,
  spread: 100,
  zoom: 1.45,
  leanMlt: 1.6,
  recoil: 0.013,
  recoilR: 0.082,
  recover: 0.982,
  recoverY: 0.992,
  recoverF: 0.98,
  recoilYM: 0.5,
  aimRecMlt: 0.1,
  recoilZM: 0.01,
  recoilZ: 4,
  recoilAnim: {
    time: 350,
    recoilTweenY: 0.39,
    recoilTweenYM: 0.25
  },
  expScale: 0.9,
  rumble: 0.7,
  icnPad: -10,
  charm: true,
  charmMXOff: -0.27,
  charmMYOff: -0.58,
  charmMZOff: 0.56,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 5,
  mysteryBoxR: 1,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Shotgun",
  src: "weapon_6",
  icon: "icon_6",
  assetIcon: "",
  sound: "weapon_6",
  refDist: 25,
  rollOff: 1,
  secondary: false,
  equipment: false,
  noSpread: false,
  noAim: false,
  akimbo: false,
  altSkin: {
    name: "Nova Pump",
    mid: 0,
    blocked: true,
    noSale: true,
    midT: 38,
    scl: 0.9,
    mScl: 1,
    zOff: 0.28,
    yOff: -0.5,
    seas: 2,
    weapon: 6,
    rarity: 0,
    charmMXOff: -0.37,
    charmMYOff: -0.2,
    charmMZOff: 1.18,
    charmMScl: 1,
    charmXOff: 0,
    charmYOff: 0,
    charmZOff: 0,
    charmScl: 1,
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  },
  noAo: true,
  nAuto: true,
  nCase: true,
  nRing: true,
  swapWiggle: 0.4,
  shine: 35,
  type: 0,
  physRang: 35,
  physPow: 0.09,
  swapTime: 300,
  aimSpd: 120,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  burst: true,
  burstC: 3,
  burstR: 60,
  ammo: 6,
  reload: 1100,
  dmg: 50,
  hsMlt: 1.25,
  dmgDrop: 50,
  scale: 0.00082934281407035,
  rightHoldX: 0.1,
  leftHoldY: -0.6,
  rightHoldY: -0.6,
  leftHoldZ: 0.4,
  rightHoldZ: -1.3,
  holdW: 1,
  xOff: 0.95,
  yOff: -0.6,
  zOff: -3.8,
  xOrg: 0,
  yOrg: -0.3,
  zOrg: -2.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  jYMlt: 0.2,
  inspectR: 0.1,
  muzID: 3,
  muzOff: 6,
  muzMlt: 1.8,
  inspectM: 1.9,
  range: 160,
  rate: 450,
  innac: 110,
  spread: 180,
  shots: 5,
  cSpread: [[0.03, 0.02, -0.27, 0.02, 0.03, -0.31, 0.3, -0.01, 0.01, 0.28], [0.01, 0.02, -0.17, -0.22, -0.3, 0.31, 0.32, 0.28, 0.3, -0.2]],
  minSpread: 20,
  zoom: 1.25,
  leanMlt: 1.6,
  recoil: 0.02,
  recoilR: 0.015,
  recover: 0.99,
  recoverF: 0.97,
  recoilZ: 2.1,
  recoilZM: 0.2,
  aimRecMlt: 0.67,
  recoilYM: 0.65,
  recoilAnim: {
    time: 340,
    recoilTweenY: 0.22
  },
  jumpYM: 0.5,
  rumble: 0.8,
  icnPad: 10,
  expScale: 0.85,
  charm: true,
  charmMXOff: -0.37,
  charmMYOff: -0.39,
  charmMZOff: 1.2,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 12,
  mysteryBoxR: 3,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "NORU",
  src: "weapon_7",
  icon: "icon_7",
  assetIcon: "",
  sound: "weapon_7",
  refDist: 25,
  rollOff: 1,
  secondary: false,
  equipment: false,
  akimbo: false,
  noAim: false,
  nAuto: false,
  noSpread: false,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 18,
  pj_spd: 2.3,
  pj_lookDir: true,
  pj_grav: 0.0001,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 3000,
  pj_snd: 0,
  physRang: 0,
  physPow: 0,
  type: 0,
  attach: 0,
  swapWiggle: 0.3,
  attachYOff: -0.085,
  attachZOff: -0.74,
  zRot: 0.75,
  noAo: true,
  swapTime: 600,
  aimSpd: 200,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 0.79,
  jumMlt: 0.85,
  ammo: 60,
  reload: 3300,
  dmg: 22,
  hsMlt: 1.5,
  pierce: 1,
  range: 700,
  dmgDrop: 10,
  jYMlt: 0.8,
  scale: 0.0008856008924623108,
  leftHoldY: -0.85,
  leftHoldX: 0.4,
  rightHoldX: -0.1,
  rightHoldY: -0.79,
  leftHoldZ: 1.1,
  rightHoldZ: -0.2,
  holdW: 1.1,
  yRot: -0.01,
  xOff: 0.95,
  yOff: -0.75,
  zOff: -2.8,
  xOrg: 0,
  yOrg: -0.6,
  zOrg: -1.8,
  cLean: 0.1,
  cRot: 0.1,
  cDrop: 0.1,
  inspectR: 0.2,
  inspectM: 0.6,
  caseInd: 2,
  caseZOff: -0.5,
  caseYOff: -0.1,
  muzID: 3,
  muzOff: 5.5,
  muzOffY: -0.14,
  muzMlt: 1.7,
  rate: 100,
  spread: 300,
  minSpread: 10,
  zoom: 1.3,
  leanMlt: 1.6,
  recoil: 0.0032,
  recoilR: 0.04,
  recover: 0.98,
  recoverY: 0.9975,
  recoverF: 0.975,
  recoilZ: 3.8,
  recoilYM: 0.25,
  recoilZ: 3,
  recoilZM: -0.1,
  aimRecMlt: 0.5,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.045,
    recoilTweenZ: 0.12
  },
  jumpYM: 0.5,
  expScale: 0.85,
  rumble: 0.65,
  icnPad: 10,
  charm: true,
  charmMXOff: -0.37,
  charmMYOff: -0.16,
  charmMZOff: 0.91,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 4,
  mysteryBoxR: 3,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Semi Auto",
  src: "weapon_8",
  icon: "icon_8",
  assetIcon: "",
  sound: "weapon_8",
  refDist: 25,
  rollOff: 1,
  noSpread: false,
  secondary: false,
  equipment: false,
  noAim: false,
  akimbo: false,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 33,
  pj_spd: 2.5,
  pj_lookDir: true,
  pj_grav: 0.0001,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 4000,
  pj_snd: 0,
  physRang: 0,
  physPow: 0,
  altSkin: {
    name: "Nova Semi",
    blocked: true,
    noSale: true,
    mid: 0,
    midT: 0,
    seas: 3,
    weapon: 8,
    rarity: 0,
    charmMXOff: -0.29999999999999993,
    charmMYOff: -0.35000000000000014,
    charmMZOff: 1.13,
    charmMScl: 1,
    charmXOff: 0,
    charmYOff: 0,
    charmZOff: 0,
    charmScl: 1,
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  },
  attach: 0,
  attachYOff: -0.08,
  attachZOff: -1.55,
  nAuto: true,
  zRot: 0.7,
  type: 0,
  noAo: true,
  swapWiggle: 0.4,
  swapTime: 300,
  aimSpd: 120,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  ammo: 12,
  reload: 1500,
  dmg: 35,
  hsMlt: 1.4571,
  lsMlt: 0.5429,
  pierce: 0.2,
  range: 1000,
  dmgDrop: 0,
  scale: 0.00093686221105528,
  leftHoldY: -0.5,
  rightHoldY: -0.45,
  leftHoldZ: 0.4,
  rightHoldZ: -1.85,
  jYMlt: 0.6,
  xOff: 0.8,
  yOff: -0.6,
  zOff: -3.5,
  xOrg: 0,
  yOrg: -0.395,
  yRot: -0.005,
  zOrg: -3.4,
  rotOff: -0.02,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  inspectR: 0.2,
  inspectM: 1.4,
  muzID: 3,
  muzOff: 4,
  muzOffY: -0.05,
  muzMlt: 1.1,
  rate: 100,
  spread: 250,
  caseZOff: -1.3,
  zoom: 2.1,
  recoil: 0.01,
  recoilR: 0.08,
  recover: 0.98,
  recoilY: 0.36,
  recoverY: 0.994,
  recoverF: 0.975,
  recoilYM: 0.6,
  recoilZ: 2,
  recoilZM: 0.2,
  aimRecMlt: 0.8,
  recoilAnim: {
    time: 250,
    recoilTweenY: 0.11,
    recoilTweenZ: 0.15
  },
  jumpYM: 0.5,
  rumble: 0.75,
  icnPad: 10,
  charm: true,
  charmMXOff: -0.2699999999999999,
  charmMYOff: -0.35000000000000014,
  charmMZOff: 1.15,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 8,
  mysteryBoxR: 2
}, {
  name: "Dream Wrecker",
  src: "weapon_9",
  icon: "icon_9",
  assetIcon: "",
  sound: "weapon_9",
  refDist: 25,
  rollOff: 1,
  noSpread: false,
  noAim: false,
  secondary: false,
  equipment: false,
  akimbo: false,
  nInsp: true,
  kill: ["", 75],
  nSkill: true,
  nAuto: false,
  nCase: true,
  nRing: true,
  noAo: true,
  projectile: {},
  pj_asset: "",
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_explode: 45,
  pj_dmg: 60,
  pj_eDmg: 45,
  pj_spd: 0.75,
  pj_grav: 0.00008,
  pj_nImp: true,
  pj_lookDir: true,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 1500,
  type: 0,
  swapTime: 350,
  swapWiggle: 0.4,
  aimSpd: 200,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 0.95,
  physRang: 46,
  physPow: 0.095,
  dmg: 25,
  ammo: 9,
  shots: 0,
  reload: 1500,
  hsMlt: 1,
  lsMlt: 1,
  scale: 0.00076263407035176,
  leftHoldX: -0.1,
  leftHoldY: -0.36,
  rightHoldY: -0.3,
  leftHoldZ: 1.2,
  rightHoldX: -0.15,
  rightHoldZ: -0.45,
  holdW: 0.9,
  jYMlt: 0.4,
  xOff: 0.95,
  yOff: -0.56,
  zOff: -2.6,
  xOrg: 0,
  yOrg: -0.945,
  zOrg: -3,
  zRot: 0.9,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  muzID: 3,
  muzOff: 5,
  muzOffY: 0,
  muzMlt: 1.5,
  rate: 320,
  spread: 120,
  minSpread: 15,
  zoom: 1.5,
  leanMlt: 1.4,
  landBob: 0.8,
  recoil: 0.008,
  recoilR: 0.012,
  recover: 0.99,
  recoverY: 0.998,
  recoverF: 0.975,
  recoilZ: 4,
  recoilZM: -0.5,
  aimRecMlt: 0.9,
  recoilAnim: {
    time: 400,
    recoilTweenY: 0.25
  },
  jumpYM: 0.3,
  expScale: 0.7,
  rumble: 1,
  rumbleDur: 750,
  icnPad: 10,
  charm: true,
  charmMXOff: -0.38999999999999996,
  charmMYOff: -0.16000000000000003,
  charmMZOff: -0.019999999999999532,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 8,
  mysteryBoxR: 0,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Akimbo Uzi",
  src: "weapon_10",
  icon: "icon_10",
  assetIcon: "",
  sound: "weapon_10",
  refDist: 25,
  rollOff: 1,
  secondary: false,
  equipment: false,
  nAuto: false,
  noAo: true,
  physRang: 0,
  physPow: 0,
  altSkin: {
    name: "Nova Uzi",
    mid: 0,
    midT: 0,
    blocked: true,
    noSale: true,
    weapon: 10,
    rarity: 0,
    seas: 3,
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  },
  nInsp: true,
  noAim: true,
  akimbo: true,
  type: 0,
  swapTime: 300,
  aimSpd: 120,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1.04,
  ammo: 30,
  reload: 1300,
  dmg: 18,
  hsMlt: 1,
  pierce: 1,
  range: 500,
  dmgDrop: 13,
  scale: 0.9,
  rightHoldY: -0.55,
  leftHoldZ: 0.2,
  leftHoldX: -0.1,
  leftHoldY: -0.55,
  rightHoldZ: 0.2,
  rightHoldX: -0.1,
  holdW: 1.3,
  xOff: 1.5,
  yOff: -0.95,
  zOff: -3.3,
  xOrg: 0,
  yOrg: -0.62,
  zOrg: -2.5,
  zLnM: 0.4,
  cLean: 0.1,
  cRot: 0.1,
  cDrop: 0.2,
  caseYOff: -0.15,
  caseZOff: -0.4,
  muzID: 3,
  muzOff: 3.6,
  rate: 70,
  spread: 0,
  noSpread: false,
  movSpread: 0.01,
  minSpread: 10,
  zoom: 1.5,
  recoil: 0.0034,
  recoilR: 0.015,
  leanMlt: 0.6,
  recover: 0.978,
  recoverY: 0.996,
  recoverF: 0.975,
  recoilZ: 5,
  recoilYM: 0.7,
  recoilAnim: {
    recoilTweenY: 0.01
  },
  expScale: 0.7,
  rumble: 0.4,
  icnPad: -4,
  charm: true,
  charmMXOff: -0.37,
  charmMYOff: -0.2,
  charmMZOff: 0.91,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 6,
  mysteryBoxR: 1
}, {
  name: "Desert Eagle",
  src: "weapon_11",
  icon: "icon_11",
  assetIcon: "",
  sound: "weapon_11",
  refDist: 25,
  rollOff: 1,
  noSpread: false,
  akimbo: false,
  secondary: true,
  equipment: false,
  noAim: false,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 50,
  pj_spd: 2.3,
  pj_lookDir: true,
  pj_grav: 0.0001,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 1500,
  pj_snd: 0,
  physRang: 0,
  physPow: 0,
  nAuto: true,
  noAo: true,
  transp: true,
  kill: ["", 50],
  type: 1,
  swapTime: 200,
  aimSpd: 110,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  ammo: 3,
  reload: 1000,
  dmg: 80,
  hsMlt: 1.2,
  pierce: 0.85,
  dmgDrop: 10,
  scale: 0.94,
  leftHoldY: -0.9,
  rightHoldY: -0.7,
  leftHoldZ: -0.5,
  rightHoldZ: -0.5,
  holdW: 1.1,
  xOff: 1,
  yOff: -0.5,
  zOff: -4.1,
  xOrg: 0,
  yOrg: -0.195,
  zOrg: -3.8,
  cLean: 0.3,
  cRot: 0.3,
  inspectR: 0.35,
  inspectM: 0.9,
  muzID: 3,
  muzOff: 2,
  muzMlt: 1.1,
  range: 700,
  rate: 350,
  spread: 150,
  jYMlt: 0.5,
  zoom: 1.4,
  leanMlt: 1.6,
  recoil: 0.01,
  recoilR: 0.01,
  recover: 0.982,
  recoverY: 0.995,
  recoverF: 0.98,
  recoilYM: 0.62,
  aimRecMlt: 0.23,
  recoilZ: 4.8,
  recoilZM: 0.2,
  recoilAnim: {
    time: 240,
    recoilTweenY: 0.42
  },
  rumble: 0.8,
  icnPad: -10,
  expScale: 1.55,
  charm: true,
  charmMXOff: -0.34,
  charmMYOff: -0.2,
  charmMZOff: 0.88,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 7,
  mysteryBoxR: 0,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Cupids Blaster",
  src: "weapon_12",
  icon: "icon_12",
  assetIcon: "",
  sound: "weapon_12",
  refDist: 25,
  rollOff: 1,
  akimbo: false,
  noSpread: false,
  noAim: false,
  noAo: true,
  physRang: 0,
  physPow: 0,
  secondary: true,
  equipment: false,
  nRing: true,
  nAuto: true,
  transp: true,
  nCase: true,
  kill: ["", 50],
  type: 1,
  swapTime: 200,
  aimSpd: 120,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  ammo: 4,
  reload: 1500,
  dmg: 45,
  hsMlt: 1.25,
  pierce: 0.85,
  dmgDrop: 10,
  scale: 1.1,
  leftHoldY: -1,
  rightHoldY: -0.65,
  leftHoldZ: -0.2,
  rightHoldZ: -0.2,
  holdW: 1,
  xOff: 1.3,
  yOff: -0.83,
  zOff: -4.1,
  xOrg: 0,
  yRot: -0.01,
  yOrg: -0.53,
  zOrg: -3.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0,
  inspectR: 0.1,
  inspectM: 0.8,
  muzID: 3,
  muzOff: 2.2,
  muzOffY: 0.1,
  muzID: 3,
  muzMlt: 1.1,
  jYMlt: 0.8,
  range: 700,
  rate: 170,
  spread: 150,
  zoom: 1.4,
  leanMlt: 1.6,
  recoil: 0.006,
  recoilR: 0.01,
  recover: 0.98,
  recoverY: 0.99,
  recoverF: 0.98,
  recoilYM: 0.2,
  recoilZ: 2.2,
  aimRecMlt: 0.3,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.32
  },
  rumble: 0.4,
  icnPad: -8,
  expScale: 1.85,
  charm: true,
  charmMXOff: -0.53,
  charmMYOff: -0.12,
  charmMZOff: 0.67,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 6,
  mysteryBoxR: 1,
  altSkin: {
    mid: 4,
    seas: 6,
    weapon: 12,
    rarity: 0
  },
  funcOnHit: (p16601, p16602) => {
    if (p16601.forceTeam) {
      p16601.forceTeam(1, 15000, 20, p16602);
    }
  }
}, {
  name: "Combat Knife",
  icon: "icon_0",
  challSrc: "weapon_k",
  assetIcon: "",
  melee: true,
  noSkins: true,
  canThrow: true,
  aimLean: 0.01,
  holdW: 0.9,
  swapWiggle: 0.3,
  sound: "melee",
  refDist: 25,
  rollOff: 1,
  hsMlt: 1,
  lsMlt: 1,
  insX: 0.1,
  inspAnim: {
    arZ: 0.3,
    arX: 0.6,
    arY: -2.2,
    apZ: -1.3,
    apX: -0.1,
    apY: 1,
    wpZ: -0.19,
    wpY: -0.4,
    wrY: -0.2
  },
  anim: function (p16603, p16604, p16605, p16606) {
    if (p16605 == 1) {
      p16603.handAnimInd = (p16603.handAnimInd || 1) * -1;
      var v13460 = false;
      if (p16603.meleeAnim.anim) {
        p16603.meleeAnim.anim.stop();
        v13460 = p16603.meleeAnim.armM >= 2;
      }
      p16603.resetMeleeAnim();
      var v13461 = -1.2;
      var vLN07100 = 0.7;
      var v13462 = -0.4;
      if (v13460) {
        v13461 += 0.1;
        p16603.meleeAnim.weaR = v13461;
        v13462 += 0.8;
        p16603.meleeAnim.armR = v13462;
        vLN07100 += 0.2;
        p16603.meleeAnim.weaM = vLN07100;
        p16603.meleeAnim.flipW = Math.PI;
      } else {
        v13461 -= 0.4;
      }
      p16603.meleeAnim.anim = new p16604.Tween(p16603.meleeAnim).to({
        armR: v13462,
        lArm: 1,
        armT: v13460 ? -0.2 : -0.8,
        armY: v13460 ? -3 : -3,
        armM: v13460 ? -10 : 13,
        armE: -2,
        weaR: v13461,
        weaM: vLN07100
      }, (v13460 ? 1.3 : 1) * 220).easing(p16604.Easing.Cubic.Out).onComplete(function () {
        p16603.meleeAnim.anim = new p16604.Tween(p16603.meleeAnim).to({
          armR: 0,
          armT: 0,
          armY: 0,
          lArm: 0,
          armM: 0,
          armE: 0,
          weaR: 0,
          weaM: 0,
          flipW: 0
        }, 350).easing(p16604.Easing.Cubic.Out).start();
      }).start();
    } else if (p16605 == 2) {
      p16603.handAnimInd = (p16603.handAnimInd || 1) * -1;
      if (p16603.meleeAnim.anim) {
        p16603.meleeAnim.anim.stop();
      }
      p16603.resetMeleeAnim();
      var vO430 = p16603.handAnimInd ? "lArm" : "";
      var vO430 = {};
      if (p16603.handAnimInd == 1) {
        vO430.lArm = -2.7;
      } else {
        vO430.rArm = -2.7;
      }
      p16603.meleeAnim.anim = new p16604.Tween(p16603.meleeAnim).to(vO430, 10).easing(p16604.Easing.Linear.None).onComplete(function () {
        p16603.meleeAnim.anim = new p16604.Tween(p16603.meleeAnim).to({
          lArm: 0,
          rArm: 0
        }, 150).easing(p16604.Easing.Linear.None).delay(100).start();
      }).start();
    } else if (p16605 == 3) {
      if (p16603.meleeAnim.anim) {
        p16603.meleeAnim.anim.stop();
      }
      p16603.resetMeleeAnim();
      p16603.meleeAnim.armR = -1.3;
      p16603.meleeAnim.armM = 1.7;
      p16603.meleeAnim.armE = 1.1;
      p16603.meleeAnim.armY = 2.9;
      p16603.meleeAnim.armT = 1;
      p16603.meleeAnim.armS = 1.7;
      p16603.meleeAnim.weaR = -0.6;
      p16603.meleeAnim.anim = new p16604.Tween(p16603.meleeAnim).to({
        armY: -9,
        armS: -0.1,
        armE: -7.5,
        armM: -1.5,
        lArm: 0.5,
        weaR: -3
      }, 300 + (200 - (p16606 || 1) * 200)).easing(p16604.Easing.Cubic.Out).onComplete(function () {
        p16603.meleeAnim.anim = new p16604.Tween(p16603.meleeAnim).to({
          armR: 0,
          armT: 0,
          armY: 0,
          lArm: 0,
          armM: 0,
          armS: 0,
          armE: 0,
          weaR: 0
        }, 350).easing(p16604.Easing.Cubic.Out).start();
      }).start();
    }
  },
  type: 2,
  swapTime: 250,
  aimSpd: 100,
  chrgTime: 0,
  ovrChrg: true,
  rate: 250,
  dmg: 50,
  dmgDrop: 0,
  range: 15,
  spdMlt: 1.1,
  spread: 100,
  leftHoldY: -0.82,
  leftHoldX: 1.5,
  rightHoldX: -1.5,
  rightHoldY: -0.82,
  leftHoldZ: -0.5,
  rightHoldZ: -0.5,
  xOff: 0,
  yOff: -0.6,
  zOff: -3.6,
  xOrg: 0.0001,
  yOrg: -0.6,
  zOrg: -3.6,
  zRM: 0.35,
  zoom: 1.2,
  leanMlt: 0.8,
  recoil: 0.006,
  recoilR: 0.01,
  recover: 0.98,
  recoverF: 0.98,
  rumble: 0.4,
  rumbleDur: 150,
  icnPad: -10,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Crossbow",
  src: "weapon_14",
  icon: "icon_14",
  assetIcon: "",
  sound: "weapon_14",
  refDist: 25,
  rollOff: 1,
  noSpread: false,
  akimbo: false,
  secondary: false,
  equipment: false,
  noAim: false,
  nInsp: true,
  nRing: true,
  nAuto: true,
  noAo: true,
  physRang: 0,
  physPow: 0,
  nCase: true,
  nMuz: true,
  attach: 0,
  attachYOff: -0.1,
  attachZOff: 0.75,
  kill: ["", 75],
  type: 0,
  projectile: {},
  pj_asset: "",
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_explode: 100,
  pj_dmg: 100,
  pj_eDmg: 100,
  pj_spd: 0.75,
  pj_grav: 0.00008,
  pj_nImp: true,
  pj_lookDir: true,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 1500,
  swapTime: 200,
  aimSpd: 120,
  chrgTime: 1300,
  chrgMlt: 0.9,
  ovrChrg: true,
  spdMlt: 1,
  ammo: 3,
  reload: 900,
  dmg: 100,
  hsMlt: 1,
  lsMlt: 1,
  pierce: 0,
  dmgDrop: 0,
  scale: 0.0007303348040201011,
  leftHoldY: -0.33,
  rightHoldY: -0.28,
  leftHoldZ: 2.2,
  leftHoldX: 0,
  rightHoldZ: 0.9,
  xOff: 1,
  yOff: -1,
  zOff: -1.4,
  xOrg: 0,
  yOrg: -0.72,
  zOrg: -0.7,
  cLean: 0.1,
  cRot: 0.1,
  zRot: 0.9,
  cDrop: 0.2,
  holdW: 0.5,
  muzID: 3,
  muzOff: 2.2,
  muzOffY: 0.1,
  muzID: 3,
  muzMlt: 1.1,
  jYMlt: 0.95,
  range: 700,
  rate: 150,
  spread: 120,
  zoom: 1.4,
  leanMlt: 0.3,
  recoil: 0.007,
  recoilR: 0.01,
  recover: 0.985,
  recoverY: 0.996,
  recoverF: 0.98,
  recoilZ: 4,
  recoilAnim: {
    time: 300,
    recoilTweenY: 0.1
  },
  rumble: 0.5,
  icnPad: 9,
  charm: true,
  charmMXOff: -0.23999999999999994,
  charmMYOff: 0.04,
  charmMZOff: -0.01,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 20,
  mysteryBoxR: 1,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Famas",
  src: "weapon_15",
  icon: "icon_15",
  assetIcon: "",
  sound: "weapon_15",
  refDist: 25,
  rollOff: 1,
  akimbo: false,
  noSpread: false,
  secondary: false,
  equipment: false,
  noAim: false,
  noAo: true,
  nAuto: true,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 28,
  pj_spd: 2.4,
  pj_lookDir: true,
  pj_grav: 0.0001,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 3000,
  pj_snd: 0,
  physRang: 0,
  physPow: 0,
  burst: true,
  burstC: 4,
  burstR: 90,
  swapWiggle: 0.6,
  attach: 0,
  attachYOff: -0.1,
  attachZOff: -0.5,
  zRot: 1,
  type: 0,
  swapTime: 300,
  aimSpd: 130,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 0.95,
  ammo: 36,
  rate: 280,
  reload: 1200,
  dmg: 28,
  hsMlt: 1.5,
  pierce: 1,
  range: 900,
  dmgDrop: 5,
  scale: 0.0008858419597989991,
  leftHoldY: -0.45,
  rightHoldY: -0.5,
  leftHoldZ: 0.72,
  rightHoldZ: -0.75,
  holdW: 1,
  xOff: 1,
  yOff: -0.86,
  yRot: 0.0018,
  zOff: -3,
  xOrg: 0,
  yOrg: -1.14,
  zOrg: -2,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  inspectR: 0.1,
  inspectM: 1.5,
  caseZOff: -1.7,
  caseYOff: -0.2,
  muzID: 3,
  muzOff: 4.9,
  muzOffY: -0.05,
  muzMlt: 1.4,
  spread: 90,
  minSpread: 5,
  zoom: 1.5,
  leanMlt: 1.5,
  recoil: 0.003,
  recoilR: 0.02,
  recover: 0.978,
  recoverY: 0.995,
  recoverF: 0.975,
  jYMlt: 0.9,
  recoilYM: 0.32,
  recoilZ: 5.5,
  recoilZM: 0.05,
  aimRecMlt: 0.65,
  recoilAnim: {
    time: 300,
    recoilTweenY: 0.06,
    recoilTweenZ: 0.1
  },
  jumpYM: 0.6,
  rumble: 0.5,
  expScale: 0.9,
  icnPad: 9,
  charm: true,
  charmMXOff: -0.33,
  charmMYOff: 0.195,
  charmMZOff: 0.99,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 5,
  mysteryBoxR: 2,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Sawed Off",
  src: "weapon_16",
  icon: "icon_16",
  assetIcon: "",
  sound: "weapon_16",
  noComp: true,
  refDist: 25,
  rollOff: 1,
  noSpread: false,
  akimbo: false,
  noAim: false,
  noAo: true,
  nAuto: true,
  nCase: true,
  nRing: true,
  secondary: true,
  equipment: false,
  swapWiggle: 0.4,
  shine: 35,
  type: 1,
  physRang: 36,
  physPow: 0.1,
  swapTime: 200,
  aimSpd: 100,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  burst: true,
  burstC: 3,
  burstR: 100,
  ammo: 3,
  reload: 1100,
  dmg: 12,
  hsMlt: 1.5,
  dmgDrop: 12,
  scale: 1,
  rightHoldX: 0.1,
  leftHoldY: -0.5,
  rightHoldY: -0.6,
  leftHoldZ: 0.4,
  rightHoldZ: -1.5,
  holdW: 1,
  xOff: 0.95,
  yOff: -0.65,
  zOff: -3.8,
  xOrg: 0,
  yOrg: -0.3,
  zOrg: -2.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  jYMlt: 0.2,
  inspectR: 0.1,
  inspectM: 1.9,
  muzID: 3,
  muzOff: 6,
  muzMlt: 1.8,
  range: 210,
  rate: 400,
  innac: 110,
  spread: 120,
  shots: 5,
  cSpread: [[0.03, 0.05, -0.27, -0.02, -0.03, 0.31, 0.3, -0.01, 0.01, -0.28], [0.01, 0.05, -0.17, -0.22, -0.3, 0.31, 0.32, 0.28, 0.3, -0.2]],
  minSpread: 20,
  zoom: 1.25,
  leanMlt: 1.6,
  recoil: 0.02,
  recoilR: 0.015,
  recover: 0.99,
  recoverF: 0.97,
  recoilZ: 2.1,
  recoilZM: 0.32,
  aimRecMlt: 0.3,
  recoilYM: 1,
  recoilAnim: {
    time: 340,
    recoilTweenY: 0.35
  },
  jumpYM: 0.5,
  rumble: 0.8,
  icnPad: 10,
  expScale: 1,
  charm: true,
  charmMXOff: -0.37,
  charmMYOff: -0.43,
  charmMZOff: 1.23,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 20,
  mysteryBoxR: 0,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Auto Pistol",
  src: "weapon_17",
  icon: "icon_17",
  assetIcon: "",
  sound: "weapon_17",
  refDist: 25,
  rollOff: 1,
  noSpread: false,
  akimbo: false,
  secondary: true,
  equipment: false,
  noAim: false,
  nAuto: false,
  noAo: true,
  physRang: 0,
  physPow: 0,
  kill: ["", 50],
  type: 1,
  swapTime: 200,
  aimSpd: 100,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  ammo: 18,
  reload: 1000,
  dmg: 16,
  hsMlt: 1.1,
  pierce: 0.95,
  dmgDrop: 2,
  scale: 0.0003158947055276376,
  leftHoldY: -1.1,
  rightHoldY: -0.62,
  leftHoldZ: -0.3,
  rightHoldZ: -0.32,
  rightHoldX: 0.13,
  holdW: 1.35,
  xOff: 1.2,
  yOff: -0.6,
  zOff: -3.7,
  xOrg: 0,
  yRot: -0.005,
  yOrg: -0.23,
  zOrg: -3.9,
  cLean: 0.3,
  cRot: 0.3,
  inspectR: 0.35,
  inspectM: 0.9,
  muzID: 3,
  muzOff: 2,
  muzMlt: 1.1,
  range: 700,
  rate: 70,
  spread: 150,
  jYMlt: 0.5,
  zoom: 1.3,
  leanMlt: 1.6,
  recoil: 0.004,
  recoilR: 0.01,
  recover: 0.98,
  recoverY: 0.99,
  recoverF: 0.98,
  recoilYM: 0.2,
  aimRecMlt: 0.4,
  recoilZ: 3.8,
  recoilZM: -0.4,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.28
  },
  rumble: 0.8,
  icnPad: -10,
  expScale: 1.55,
  charm: true,
  charmMXOff: -0.31999999999999995,
  charmMYOff: -0.17,
  charmMZOff: 0.9900000000000007,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 6,
  mysteryBoxR: 1,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Bomb",
  src: "weapon_18",
  icon: "icon_18",
  assetIcon: "",
  sound: "weapon_18",
  refDist: 25,
  rollOff: 1,
  transp: true,
  bomb: true,
  equipment: true,
  nInsp: true,
  noAim: true,
  noAo: true,
  nCase: true,
  noCross: true,
  nMuz: true,
  type: 3,
  aimSpd: 140,
  chrgTime: 0,
  ovrChrg: false,
  swapTime: 250,
  spdMlt: 0.65,
  scale: 0.63,
  holdW: 1.2,
  zoom: 1,
  rot: [0, Math.PI / 2, -0.4],
  leftHoldY: -0.3,
  rightHoldY: -0.3,
  leftHoldZ: 0.33,
  rightHoldX: -0.82,
  leftHoldX: 0.82,
  rightHoldZ: 0.33,
  xOff: 0,
  yOff: -0.8,
  zOff: -3.5,
  xOrg: 0.0001,
  yOrg: 0.0001,
  zOrg: 0.0001,
  cLean: 0,
  cRot: 0,
  cDrop: 0.12,
  jYMlt: 0.95,
  spread: 120,
  recover: 0.98,
  recoverF: 0.98,
  leanMlt: 0.3,
  icnPad: 9
}, {
  name: "Blaster",
  src: "weapon_19",
  icon: "icon_19",
  assetIcon: "",
  sound: "weapon_19",
  refDist: 25,
  rollOff: 1,
  secondary: false,
  equipment: false,
  noSpread: false,
  akimbo: false,
  noAim: false,
  noAo: true,
  nCase: true,
  nAuto: false,
  physRang: 0,
  physPow: 0,
  swapWiggle: 0.3,
  attach: 0,
  attachYOff: -0.07,
  attachZOff: -0.73,
  zRot: 1,
  type: 0,
  kill: ["", 75],
  swapTime: 300,
  aimSpd: 130,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 0.95,
  ammo: 16,
  rate: 110,
  reload: 1100,
  dmg: 1,
  projectile: {},
  pj_asset: "",
  pj_mat: "BASIC",
  pj_color: 9109499,
  pj_spd: 1,
  pj_grav: 0,
  pj_nImp: true,
  pj_lookDir: true,
  pj_scale: 0.7,
  pj_dmg: 35,
  pj_length: 10,
  pj_range: 500,
  hsMlt: 1.5,
  lsMlt: 1,
  pierce: 1,
  range: 700,
  dmgDrop: 0,
  scale: 0.0007946847095477368,
  leftHoldY: -0.8,
  rightHoldY: -0.6,
  leftHoldZ: 1.2,
  rightHoldZ: -1.25,
  holdW: 0.75,
  xOff: 0.7,
  yOff: -0.76,
  zOff: -3,
  rotOff: -0.05,
  rotOffA: -0.02,
  aimOffY: 0.042,
  yRot: 0.0018,
  xOrg: 0,
  yOrg: -0.52,
  zOrg: -2.3,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  inspectR: 0.1,
  inspectM: 1.5,
  caseZOff: -1.7,
  caseYOff: -0.2,
  muzID: 3,
  muzOff: 5.1,
  muzOffY: -0.08,
  muzMlt: 1.4,
  spread: 100,
  minSpread: 5,
  zoom: 1.6,
  leanMlt: 1.5,
  recoil: 0.003,
  recoilR: 0.05,
  recover: 0.978,
  recoverY: 0.995,
  recoverF: 0.975,
  jYMlt: 0.9,
  recoilYM: 0.4,
  recoilZ: 5.7,
  recoilZM: -0.05,
  aimRecMlt: 0.7,
  recoilAnim: {
    time: 300,
    recoilTweenY: 0.07,
    recoilTweenZ: 0.1
  },
  jumpYM: 0.6,
  rumble: 0.5,
  icnPad: 5,
  charm: true,
  charmMXOff: -0.37,
  charmMYOff: -0.17,
  charmMZOff: 0.98,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 5,
  mysteryBoxR: 1,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Build Tool",
  src: "weapon_20",
  icon: "icon_20",
  assetIcon: "",
  sound: "weapon_20",
  refDist: 25,
  rollOff: 1,
  aimSound: "paper_1",
  swapSnd: "paper_1",
  build: true,
  equipment: true,
  nInsp: true,
  noAim: false,
  noAo: true,
  nCase: true,
  noCross: true,
  nMuz: true,
  side: 2,
  type: 3,
  aimSpd: 100,
  chrgTime: 0,
  ovrChrg: false,
  aimLean: 0.000001,
  swapTime: 200,
  spdMlt: 0.9,
  scale: 1.2,
  holdW: 1.3,
  zoom: 1.1,
  rate: 300,
  range: 50,
  rot: [0, Math.PI / 2, -0.4],
  leftHoldY: 0.6,
  rightHoldY: 0.6,
  leftHoldZ: 0.1,
  rightHoldX: -2.2,
  leftHoldX: 2.2,
  rightHoldZ: 0.1,
  xOff: 0,
  yOff: -2.6,
  zOff: -3.5,
  xOrg: 0.00001,
  yOrg: -3.8,
  zOrg: -3.2,
  cLean: 0,
  cRot: 0,
  cDrop: 0.12,
  jYMlt: 0.95,
  spread: 120,
  recover: 0.98,
  recoverF: 0.98,
  leanMlt: 0.3,
  icnPad: 9
}, {
  name: "Grappler",
  src: "weapon_21",
  icon: "icon_21",
  assetIcon: "",
  sound: "weapon_21",
  refDist: 25,
  rollOff: 1,
  noSpread: true,
  akimbo: false,
  secondary: true,
  equipment: false,
  noAim: false,
  grapRang: 500,
  physRang: 0,
  physPow: 0,
  nAuto: true,
  noAo: true,
  transp: true,
  kill: ["", 50],
  type: 1,
  swapTime: 200,
  aimSpd: 110,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  ammo: 10,
  reload: 1000,
  dmg: 1,
  hsMlt: 1.5,
  pierce: 0.85,
  dmgDrop: 0,
  scale: 1,
  leftHoldY: -0.9,
  rightHoldY: -0.7,
  leftHoldZ: -0.5,
  rightHoldZ: -0.5,
  holdW: 1.1,
  xOff: 1,
  yOff: -0.5,
  zOff: -4.1,
  xOrg: 0,
  yOrg: -0.195,
  zOrg: -3.8,
  cLean: 0.3,
  cRot: 0.3,
  inspectR: 0.35,
  inspectM: 0.9,
  muzID: 3,
  muzOff: 1.8,
  muzOffY: -0.2,
  muzMlt: 1.1,
  range: 700,
  rate: 300,
  spread: 0,
  jYMlt: 0.5,
  zoom: 1.2,
  leanMlt: 1.6,
  recoil: 0.01,
  recoilR: 0.01,
  recover: 0.982,
  recoverY: 0.995,
  recoverF: 0.98,
  recoilYM: 0.62,
  aimRecMlt: 0.23,
  recoilZ: 4.8,
  recoilZM: 0.2,
  recoilAnim: {
    time: 180,
    recoilTweenY: 0.34
  },
  rumble: 0.8,
  icnPad: -10,
  expScale: 1.2,
  charm: true,
  charmMXOff: -0.34,
  charmMYOff: -0.2,
  charmMZOff: 0.36,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1
}, {
  name: "Tehchy-9",
  src: "weapon_22",
  icon: "icon_22",
  assetIcon: "",
  sound: "weapon_22",
  refDist: 25,
  rollOff: 1,
  noSpread: false,
  akimbo: false,
  secondary: true,
  equipment: false,
  noAim: false,
  nAuto: true,
  noAo: true,
  physRang: 0,
  physPow: 0,
  burst: true,
  burstC: 3,
  burstR: 80,
  kill: ["", 50],
  type: 1,
  swapTime: 200,
  aimSpd: 100,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  ammo: 18,
  reload: 1000,
  dmg: 23,
  hsMlt: 1.25,
  pierce: 0.95,
  dmgDrop: 2,
  scale: 0.0003158947055276376,
  leftHoldY: -1.1,
  rightHoldY: -0.62,
  leftHoldZ: -0.3,
  rightHoldZ: -0.32,
  rightHoldX: 0.13,
  holdW: 1.35,
  xOff: 1.2,
  yOff: -0.6,
  zOff: -3.7,
  xOrg: 0,
  yRot: -0.005,
  yOrg: -0.23,
  zOrg: -3.9,
  cLean: 0.3,
  cRot: 0.3,
  inspectR: 0.35,
  inspectM: 0.9,
  muzID: 3,
  muzOff: 2,
  muzMlt: 1.1,
  range: 700,
  rate: 380,
  spread: 150,
  jYMlt: 0.5,
  zoom: 1.3,
  leanMlt: 1.6,
  recoil: 0.004,
  recoilR: 0.01,
  recover: 0.98,
  recoverY: 0.99,
  recoverF: 0.98,
  recoilYM: 0.2,
  aimRecMlt: 0.4,
  recoilZ: 3.8,
  recoilZM: -0.4,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.28
  },
  rumble: 0.8,
  icnPad: -10,
  expScale: 1.55,
  charm: true,
  charmMXOff: -0.329,
  charmMYOff: -0.23,
  charmMZOff: 1.03,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 6,
  mysteryBoxR: 0,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Noob Tube",
  src: "weapon_23",
  icon: "icon_23",
  assetIcon: "",
  sound: "weapon_23",
  noComp: true,
  refDist: 25,
  rollOff: 1,
  noSpread: false,
  akimbo: false,
  noAim: false,
  noAo: true,
  nCase: true,
  nRing: true,
  secondary: true,
  equipment: false,
  swapWiggle: 0.4,
  shine: 35,
  type: 1,
  physRang: 36,
  physPow: 0.1,
  swapTime: 200,
  aimSpd: 100,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  ammo: 2,
  reload: 1200,
  dmg: 12,
  hsMlt: 1,
  lsMlt: 1,
  dmgDrop: 12,
  scale: 1,
  rightHoldX: 0.1,
  leftHoldY: -0.6,
  rightHoldY: -0.6,
  leftHoldZ: 0.4,
  rightHoldZ: -1.3,
  holdW: 1,
  xOff: 0.95,
  yOff: -0.6,
  zOff: -3.8,
  wzOff: 0.28,
  wyOff: -0.5,
  xOrg: 0,
  yOrg: -0.3,
  zOrg: -2.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  jYMlt: 0.2,
  inspectR: 0.1,
  muzID: 3,
  muzOff: 6,
  muzMlt: 1.8,
  inspectM: 1.9,
  range: 150,
  rate: 400,
  innac: 110,
  spread: 20,
  noSpread: true,
  noProjSpread: true,
  shots: 0,
  minSpread: 20,
  zoom: 1.25,
  leanMlt: 1.6,
  recoil: 0.02,
  recoilR: 0.015,
  recover: 0.99,
  recoverF: 0.97,
  recoilZ: 2.1,
  recoilZM: 0.32,
  aimRecMlt: 0.3,
  recoilYM: 1,
  recoilAnim: {
    time: 340,
    recoilTweenY: 0.35
  },
  jumpYM: 0.5,
  rumble: 0.8,
  icnPad: 10,
  expScale: 1,
  projectile: {},
  pj_asset: "",
  pj_mat: "BASIC",
  pj_color: 16498733,
  pj_explode: 45,
  pj_dmg: 50,
  pj_eDmg: 40,
  pj_spd: 0.75,
  pj_grav: 0.001,
  pj_nImp: true,
  pj_lookDir: true,
  pj_scale: 1.4,
  pj_length: 15,
  pj_range: 1000,
  charm: true,
  charmMXOff: -0.37,
  charmMYOff: -0.51,
  charmMZOff: -1.69,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 20,
  mysteryBoxR: 0,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Slimer",
  src: "weapon_24",
  icon: "icon_24",
  assetIcon: "",
  sound: "weapon_24",
  refDist: 25,
  rollOff: 1,
  noSpread: true,
  akimbo: false,
  noAim: true,
  physRang: 0,
  physPow: 0,
  customOnly: true,
  nAuto: true,
  noAo: true,
  transp: true,
  kill: ["", 50],
  secondary: false,
  equipment: true,
  type: 3,
  swapWiggle: 0.3,
  zRot: 1,
  swapTime: 200,
  aimSpd: 110,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  ammo: 2,
  reload: 5000,
  noReload: true,
  removeOnEmpty: true,
  dmg: 1,
  hsMlt: 1.5,
  pierce: 0.85,
  dmgDrop: 0,
  scale: 0.000765961165829144,
  leftHoldY: -0.41,
  rightHoldY: -0.6,
  leftHoldZ: 0.5,
  rightHoldZ: -1.2,
  holdW: 0.8,
  xOff: 0.7,
  yOff: -0.87,
  zOff: -3.33,
  rotOff: -0.08,
  rotOffA: -0.035,
  aimOffY: 0.042,
  yRot: 0.0018,
  xOrg: 0,
  yOrg: -0.59,
  zOrg: -2.14,
  cLean: 0.2,
  cRot: 0.1,
  cDrop: 0.1,
  inspectR: 0.1,
  inspectM: 1.5,
  caseZOff: -1.7,
  caseYOff: -0.2,
  muzID: 3,
  muzOff: 5.1,
  muzOffY: -0.05,
  muzMlt: 1.4,
  range: 700,
  rate: 300,
  minSpread: 0,
  spread: 0,
  zoom: 1.6,
  leanMlt: 1.5,
  recoil: 0.003,
  recoilR: 0.05,
  recover: 0.978,
  recoverY: 0.995,
  recoverF: 0.975,
  jYMlt: 0.9,
  recoilYM: 1.1,
  recoilZ: 4.3,
  recoilZM: -0.04,
  aimRecMlt: 0.65,
  recoilAnim: {
    time: 160,
    recoilTweenY: 0.065,
    recoilTweenZ: 0.1
  },
  jumpYM: 0.3,
  rumble: 0.4,
  icnPad: -15,
  shine: 20,
  hDstOff: 1.2,
  deployRang: 250,
  deployable: 5
}, {
  name: "Zapper",
  src: "weapon_25",
  icon: "icon_25",
  assetIcon: "",
  sound: "weapon_25",
  refDist: 25,
  rollOff: 1,
  secondary: true,
  equipment: false,
  noSpread: false,
  akimbo: false,
  noAim: false,
  noAo: true,
  transp: true,
  nAuto: true,
  noComp: true,
  projectile: {},
  pj_asset: "",
  pj_mat: "BASIC",
  pj_color: 16498733,
  pj_spd: 0.5,
  pj_grav: 0,
  pj_nImp: true,
  pj_lookDir: true,
  pj_scale: 0.8,
  pj_dmg: 5,
  pj_length: 10,
  pj_range: 150,
  physRang: 0,
  physPow: 0,
  kill: ["", 75],
  swapWiggle: 0.3,
  type: 1,
  shine: 10,
  swapTime: 260,
  aimSpd: 110,
  chrgTime: 1500,
  ovrChrg: true,
  spdMlt: 1.05,
  ammo: 10,
  reload: 1400,
  dmg: 12,
  hsMlt: 1,
  lsMlt: 1,
  range: 150,
  dmgDrop: 10,
  scale: 0.84,
  wzOff: 0,
  wyOff: 0,
  leftHoldY: -1.1,
  rightHoldY: -0.62,
  leftHoldZ: -0.3,
  rightHoldZ: -0.32,
  rightHoldX: 0.13,
  holdW: 1.3,
  xOff: 1.2,
  yOff: -0.6,
  zOff: -3.7,
  xOrg: 0,
  yRot: -0.005,
  yOrg: -0.23,
  zOrg: -3.9,
  jYMlt: 0.1,
  cLean: 0.3,
  cRot: 0.3,
  caseZOff: 0.2,
  caseYOff: 0,
  inspectR: 0.3,
  inspectM: 0.8,
  muzID: 3,
  muzOff: 1.5,
  muzOffY: 0,
  muzMlt: 0.95,
  rate: 150,
  spread: 60,
  zoom: 1.4,
  leanMlt: 1,
  recoil: 0.006,
  recoilR: 0.02,
  recover: 0.98,
  recoverY: 0.99,
  recoverF: 0.98,
  recoilYM: 0.2,
  aimRecMlt: 0.4,
  recoilZ: 3.8,
  recoilZM: -0.4,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.28,
    recoilTweenZ: 0.1
  },
  rumble: 0.4,
  icnPad: -15,
  expScale: 1.2,
  effectOnHit: 8,
  charm: true,
  charmMXOff: -0.289,
  charmMYOff: -0.16,
  charmMZOff: 1.09,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 12,
  mysteryBoxR: 0,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Minigun",
  src: "weapon_26",
  icon: "icon_26",
  assetIcon: "",
  sound: "weapon_26",
  refDist: 25,
  rollOff: 1,
  akimbo: false,
  noAim: false,
  nAuto: false,
  noSpread: false,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 16777179,
  pj_dmg: 18,
  pj_spd: 2.3,
  pj_lookDir: true,
  pj_grav: 0.0001,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 3000,
  pj_snd: 0,
  physRang: 0,
  physPow: 0,
  type: 3,
  equipment: true,
  swapWiggle: 0.3,
  zRot: 0.75,
  noAo: true,
  swapTime: 600,
  aimSpd: 200,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 0.5,
  jumMlt: 0.2,
  noJump: true,
  ammo: 250,
  reload: 3300,
  noReload: true,
  removeOnEmpty: true,
  dmg: 18,
  hsMlt: 1.5,
  pierce: 1,
  range: 700,
  dmgDrop: 10,
  jYMlt: 0.8,
  scale: 0.0008856008924623108,
  leftHoldY: -0.5,
  leftHoldX: 0.4,
  rightHoldX: -0.1,
  rightHoldY: -1.6,
  leftHoldZ: 1,
  rightHoldZ: -0.6,
  holdW: 1,
  yRot: -0.01,
  xOff: 0.95,
  yOff: -1,
  zOff: -2.8,
  xOrg: 0,
  yOrg: -0.6,
  zOrg: -1.8,
  cLean: 0.1,
  cRot: 0.1,
  cDrop: 0.1,
  inspectR: 0.2,
  inspectM: 0.6,
  caseInd: 2,
  caseZOff: -0.5,
  caseYOff: -0.1,
  muzID: 3,
  muzOff: 5,
  muzOffY: -1.2,
  muzMlt: 1.7,
  rate: 70,
  spread: 300,
  minSpread: 10,
  zoom: 1.3,
  leanMlt: 1.6,
  recoil: 0.0032,
  recoilR: 0.04,
  recover: 0.98,
  recoverY: 0.9975,
  recoverF: 0.975,
  recoilZ: 3.8,
  recoilYM: 0.25,
  recoilZ: 3,
  recoilZM: -0.1,
  aimRecMlt: 0.5,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.045,
    recoilTweenZ: 0.12
  },
  jumpYM: 0.1,
  expScale: 0.85,
  rumble: 0.65,
  icnPad: 10,
  noSwap: true,
  magReserve: 0
}, {
  name: "War Machine",
  src: "weapon_27",
  icon: "icon_27",
  assetIcon: "",
  sound: "weapon_27",
  noComp: true,
  refDist: 25,
  rollOff: 1,
  akimbo: false,
  noAim: false,
  noAo: true,
  nAuto: true,
  nCase: true,
  nRing: true,
  secondary: false,
  equipment: true,
  swapWiggle: 0.4,
  shine: 35,
  type: 3,
  physRang: 0,
  physPow: 0,
  swapTime: 400,
  aimSpd: 100,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1,
  ammo: 6,
  reload: 2000,
  noReload: true,
  removeOnEmpty: true,
  dmg: 12,
  hsMlt: 1,
  lsMlt: 1,
  dmgDrop: 12,
  scale: 1,
  rightHoldX: 0.1,
  leftHoldY: -0.6,
  rightHoldY: -0.6,
  leftHoldZ: 0.4,
  rightHoldZ: -1.3,
  holdW: 1,
  xOff: 0.95,
  yOff: -0.6,
  zOff: -3.8,
  wzOff: 0.28,
  wyOff: -0.5,
  aimY: 0.25,
  xOrg: 0,
  yOrg: -0.3,
  zOrg: -2.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  jYMlt: 0.2,
  inspectR: 0.1,
  muzID: 3,
  muzOff: 6,
  muzMlt: 1.8,
  inspectM: 1.9,
  range: 150,
  rate: 300,
  innac: 110,
  spread: 20,
  noSpread: true,
  noProjSpread: true,
  shots: 0,
  minSpread: 20,
  zoom: 1.25,
  leanMlt: 1.6,
  recoil: 0.02,
  recoilR: 0.015,
  recover: 0.99,
  recoverF: 0.97,
  recoilZ: 2.1,
  recoilZM: 0.32,
  aimRecMlt: 0.3,
  recoilYM: 1,
  recoilAnim: {
    time: 340,
    recoilTweenY: 0.35
  },
  jumpYM: 0.5,
  rumble: 0.8,
  icnPad: 10,
  expScale: 1,
  projectile: {},
  pj_asset: "",
  pj_mat: "BASIC",
  pj_color: 16498733,
  pj_explode: 70,
  pj_dmg: 60,
  pj_eDmg: 65,
  pj_spd: 0.75,
  pj_grav: 0.001,
  pj_nImp: true,
  pj_lookDir: true,
  pj_scale: 1.4,
  pj_length: 15,
  pj_range: 1000,
  noSwap: true,
  magReserve: 0
}, {
  name: "Akimbo Pistol",
  src: "weapon_28",
  icon: "icon_28",
  assetIcon: "",
  sound: "weapon_28",
  refDist: 25,
  rollOff: 1,
  secondary: true,
  equipment: false,
  nAuto: true,
  noAo: true,
  physRang: 0,
  physPow: 0,
  nInsp: true,
  noAim: true,
  akimbo: true,
  type: 1,
  swapTime: 300,
  aimSpd: 120,
  chrgTime: 0,
  ovrChrg: false,
  spdMlt: 1.04,
  ammo: 15,
  reload: 750,
  dmg: 15,
  hsMlt: 1.4,
  pierce: 1,
  range: 700,
  dmgDrop: 13,
  scale: 0.0003158947055276376,
  leftHoldZ: -0.3,
  leftHoldX: 0.13,
  leftHoldY: -0.62,
  rightHoldZ: -0.3,
  rightHoldX: 0.13,
  rightHoldY: -0.62,
  holdW: 1.3,
  xOff: 1.5,
  yOff: -0.95,
  zOff: -3.3,
  xOrg: 0,
  yOrg: -0.62,
  zOrg: -2.5,
  zLnM: 0.4,
  cLean: 0.1,
  cRot: 0.1,
  cDrop: 0.2,
  caseYOff: -0.15,
  caseZOff: -0.4,
  muzID: 3,
  muzOff: 3.6,
  rate: 90,
  spread: 40,
  noSpread: false,
  movSpread: 0.1,
  minSpread: 10,
  zoom: 1.5,
  recoil: 0.0034,
  recoilR: 0.015,
  leanMlt: 0.6,
  recover: 0.978,
  recoverY: 0.996,
  recoverF: 0.975,
  recoilZ: 5,
  recoilYM: 0.7,
  recoilAnim: {
    recoilTweenY: 0.01
  },
  expScale: 0.7,
  rumble: 0.4,
  icnPad: -4,
  charm: true,
  charmMXOff: -0.2699999999999999,
  charmMYOff: -0.42000000000000015,
  charmMZOff: -0.040000000000000646,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 6,
  mysteryBoxR: 0,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}, {
  name: "Charge Rifle",
  src: "weapon_29",
  icon: "icon_29",
  assetIcon: "",
  sound: "weapon_29",
  refDist: 25,
  rollOff: 1,
  equipment: false,
  secondary: false,
  noSpread: false,
  projectile: {},
  pj_asset: "",
  pj_disable: true,
  pj_mat: "BASIC",
  pj_color: 9109499,
  pj_dmg: 100,
  pj_spd: 2.5,
  pj_lookDir: true,
  pj_grav: 0.0001,
  pj_scale: 1.4,
  pj_length: 10,
  pj_range: 7000,
  pj_snd: 0,
  akimbo: false,
  noAim: false,
  animWhileAim: true,
  trailChrg: true,
  physRang: 0,
  physPow: 0,
  noAo: true,
  nAuto: false,
  type: 0,
  scope: true,
  swapTime: 300,
  aimSpd: 120,
  chrgTime: 700,
  ovrChrg: false,
  shootChrg: true,
  bypassChrg: true,
  chrgDec: 0.8,
  fullChrgSht: true,
  fullChrgMlt: 50,
  rateChrg: true,
  spdMlt: 0.95,
  shots: 3,
  cSpread: [[-0.27, 0.02, 0.03, -0.31, 0.3, -0.01], [-0.17, -0.22, -0.3, 0.31, 0.32, 0.28]],
  ammo: 1,
  dmg: 15,
  hsMlt: 1,
  pierce: 1,
  reload: 1400,
  range: 1000,
  dmgDrop: 5,
  scale: 0.00115608717587935,
  leftHoldY: -0.65,
  rightHoldY: -0.68,
  leftHoldZ: 2.5,
  rightHoldZ: 0.75,
  holdW: 1,
  xOff: 0.8,
  yOff: -0.65,
  zOff: -1.8,
  wzOff: -1,
  xOrg: 0,
  yOrg: -0.55,
  zOrg: -0.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  inspectR: 0.2,
  inspectM: 0.1,
  muzID: 3,
  muzOff: 8,
  muzMlt: 1.6,
  rate: 150,
  spread: 150,
  minSpread: 5,
  zoom: 2,
  leanMlt: 1.5,
  recoil: 0.003,
  recoilR: 0.05,
  recover: 0.978,
  recoverY: 0.995,
  recoverF: 0.975,
  jYMlt: 0.9,
  recoilYM: 1.1,
  recoilZ: 4.3,
  recoilZM: -0.04,
  aimRecMlt: 0.65,
  recoilAnim: {
    time: 160,
    recoilTweenY: 0.065,
    recoilTweenZ: 0.1
  },
  jumpYM: 0.15,
  rumble: 0.9,
  rumbleDur: 500,
  icnPad: 9,
  charm: true,
  charmMXOff: -0.43,
  charmMYOff: -0.4,
  charmMZOff: -3.71,
  charmMScl: 1,
  charmXOff: 0,
  charmYOff: 0,
  charmZOff: 0,
  charmScl: 1,
  magReserve: 30,
  mysteryBoxR: 4,
  altSkin: {
    projection: true,
    video: 2,
    outline: 0,
    outlineS: 1.05
  }
}];
module.exports.findWeaponBySrc = function (p16607) {
  for (var vLN02430 = 0; vLN02430 < module.exports.length; ++vLN02430) {
    if (module.exports[vLN02430].src == "weapon_" + p16607) {
      return module.exports[vLN02430];
    }
  }
  return null;
};
module.exports.findIndexBySrc = function (p16608) {
  for (var vLN02431 = 0; vLN02431 < module.exports.length; ++vLN02431) {
    if (module.exports[vLN02431].src == p16608) {
      return vLN02431;
    }
  }
  return null;
};
for (var vLN02432 = 0; vLN02432 < module.exports.length; ++vLN02432) {
  module.exports[vLN02432].id = vLN02432;
  module.exports[vLN02432].upgraded = true;
  module.exports[vLN02432].sound = "weapon_upgraded";
  if (module.exports[vLN02432].adSpread == null) {
    module.exports[vLN02432].adSpread = 0;
  }
  if (module.exports[vLN02432].reloY == null) {
    module.exports[vLN02432].reloY = 1;
  }
  if (module.exports[vLN02432].movSpread == null) {
    module.exports[vLN02432].movSpread = 1;
  }
  if (module.exports[vLN02432].lsMlt == null) {
    module.exports[vLN02432].lsMlt = 0.5;
  }
  if (module.exports[vLN02432].burst == null) {
    module.exports[vLN02432].burst = false;
    module.exports[vLN02432].burstC = 0;
    module.exports[vLN02432].burstR = 50;
  }
}